import { useEffect, useState } from 'react';
import { api } from '@/lib/api';

interface HealthResponse {
  ok: boolean;
  version?: string;
}

interface UseBackendVersionResult {
  version: string | null;
  isLoading: boolean;
}

export function useBackendVersion(enabled: boolean): UseBackendVersionResult {
  const [version, setVersion] = useState<string | null>(null);
  const [isLoading, setIsLoading] = useState<boolean>(false);

  useEffect(() => {
    let cancelled = false;

    if (enabled) {
      setIsLoading(true);
      api
        .get<HealthResponse>('/health')
        .then((data) => {
          if (cancelled) return;
          setVersion(data.version ?? null);
        })
        .catch((error: unknown) => {
          if (cancelled) return;
          console.error('[useBackendVersion] /health failed', error);
          setVersion(null);
        })
        .finally(() => {
          if (cancelled) return;
          setIsLoading(false);
        });
    } else {
      setVersion(null);
      setIsLoading(false);
    }

    return () => {
      cancelled = true;
    };
  }, [enabled]);

  return { version, isLoading };
}
